"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find-index");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _system = require("@/api/system.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      loading: true,
      currentEditId: '',
      //当前流转管理某一个的id
      arr: ['基本信息', '状态定义', '流转设置'],
      committeeArr: [],
      //仲裁委列表
      isActive: 0,
      canClickIsActive1: false,
      //是否点击步骤数字   新增流程时，得完善基础信息才给点击2，3步骤
      canClickIsActive2: false,
      //是否点击步骤数字   新增流程时，得完善基础信息才给点击2，3步骤
      laodingBtn1: false,
      laodingBtn2: false,
      ruleForm: {
        name: '',
        region: '',
        desc: '',
        status: '',
        reviewId: '',
        reviewName: '',
        autoStatus: '',
        timeLimitStatus: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入工作流名称',
          trigger: 'blur'
        }],
        region: [{
          required: true,
          message: '请选择仲裁委',
          trigger: 'change'
        }],
        reviewId: [{
          required: true,
          message: '请选择初始审核人',
          trigger: 'change'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }]
      },
      tableData: [],
      currentRadio: '',
      statusList: [],
      //全部状态别名列表
      currentStatusItem: '',
      //当前被选择的某一个状态
      statusIndex: '',
      //点击编辑状态时，表格的index值
      statusTitle: '',
      statusVisible: false,
      //状态修改弹窗
      statusform: {
        originName: '',
        alias: '',
        desc: '',
        remindDay: 0
      },
      transferCol: [],
      transferTableData: [
        // {
        //   id: '1',
        //   statusName: '规划中',
        //   checked:[true,true,false,true]
        // checked:[{id:1,checkedVal:true}]
        // },
      ],
      transferPopupVisible: false,
      transferForm: {
        auditor: [],
        Sentence: '',
        auditorRole: []
      },
      auditor: [],
      auditorRole: [],
      allNode: [],
      currentCommiteeId: '',
      //当前所选仲裁委id
      currentFlowId: '',
      //当前节点的id
      auditorList: [],
      //审核用户列表
      auditorRoleList: [],
      //审核角色列表
      nodeOfauditorOpinionList: [],
      //每个节点的处理人列表
      sortable: null
    };
  },
  created: function created() {
    this.init();
    if (this.$route.params.id) {
      this.canClickIsActive = true;
      this.currentEditId = this.$route.params.id;
      // 基础信息显示
      this.getProcessBasic();
      this.initStep();
    } else {
      this.loading = false;
      this.canClickIsActive = false;
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields();
      }
    }
  },
  mounted: function mounted() {
    // this.initStep()
  },
  methods: {
    //初始化仲裁委列表  原始状态列表
    init: function init() {
      var _this = this;
      //仲裁委员会列表
      (0, _system.getAllCommission)().then(function (res) {
        if (res.code == 1) {
          _this.committeeArr = res.data;
        }
      });
      //原始状态列表
      (0, _system.getProcessStateAll)().then(function (res) {
        if (res.code == 1) {
          _this.statusList = res.data;
        }
      });
    },
    // 当前编辑的工作流步骤
    currentEdit: function currentEdit(index) {
      if (this.currentEditId) {
        this.isActive = index;
      } else {
        if (this.canClickIsActive1 && index == 1) {
          this.isActive = 1;
        } else if (this.canClickIsActive2 && index == 2) {
          this.isActive = 2;
        } else {
          this.$message('请先填写并保存信息');
        }
      }
    },
    //获取基本信息
    getProcessBasic: function () {
      var _getProcessBasic = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$checkSinglePro, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _system.checkSingleProcessBasic)(this.currentEditId);
            case 2:
              _yield$checkSinglePro = _context.sent;
              data = _yield$checkSinglePro.data;
              this.loading = false;
              this.ruleForm.name = data.name;
              this.ruleForm.region = data.commName;
              this.ruleForm.desc = data.content;
              this.ruleForm.status = data.status == 1 ? '启用' : '禁用';
              this.ruleForm.autoStatus = data.autoStatus == 1 ? '启用' : '禁用';
              this.ruleForm.timeLimitStatus = data.timeLimitStatus == 1 ? '启用' : '禁用';
              this.currentCommiteeId = data.commId;
              if (data.reviewId) {
                this.ruleForm.reviewId = data.reviewId;
              }
              if (data.reviewName) {
                this.ruleForm.reviewName = data.reviewName;
              }
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProcessBasic() {
        return _getProcessBasic.apply(this, arguments);
      }
      return getProcessBasic;
    }(),
    //获取状态定义信息
    getProcessStateList: function () {
      var _getProcessStateList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        var _yield$getProcessDefi, data, index;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _system.getProcessDefineStatusList)({
                processId: this.currentEditId
              });
            case 2:
              _yield$getProcessDefi = _context2.sent;
              data = _yield$getProcessDefi.data;
              this.tableData = data;
              if (data.length > 0) {
                index = data.findIndex(function (item, index) {
                  return item.startStatus == 1;
                });
                this.radio = index;
                this.currentRadio = data[0].id;
              }
              this.laodingBtn1 = false;
              this.isActive = 1;
              this.$nextTick(function () {
                _this2.setSort();
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getProcessStateList() {
        return _getProcessStateList.apply(this, arguments);
      }
      return getProcessStateList;
    }(),
    // 获取流转设置列表
    getProcessSet: function () {
      var _getProcessSet = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this3 = this;
        var _yield$getProcessSetL, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _system.getProcessSetList)({
                processId: this.currentEditId
              });
            case 2:
              _yield$getProcessSetL = _context3.sent;
              data = _yield$getProcessSetL.data;
              this.laodingBtn2 = false;
              this.allNode = [];
              this.allNode = data;
              data.forEach(function (item, index) {
                var rowIndex = _this3.transferTableData.findIndex(function (ele) {
                  return ele.id == item.xProcessNode;
                });
                var colIndex = _this3.transferCol.findIndex(function (ele) {
                  return ele.id == item.yProcessNode;
                });
                _this3.transferTableData[rowIndex].checked[colIndex] = true;
              });
              this.isActive = 2;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getProcessSet() {
        return _getProcessSet.apply(this, arguments);
      }
      return getProcessSet;
    }(),
    getCurrentCommiteeId: function getCurrentCommiteeId(data) {
      if (data) {
        var committItem = this.committeeArr.find(function (ele) {
          return ele.name == data;
        });
        this.currentCommiteeId = committItem.id;
        this.getAuditorList();
      }
    },
    // 获取流转设置审核用户列表
    getAuditorList: function () {
      var _getAuditorList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var _yield$getProcessSetA, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _system.getProcessSetAuditorList)({
                commId: this.currentCommiteeId
              });
            case 2:
              _yield$getProcessSetA = _context4.sent;
              data = _yield$getProcessSetA.data;
              this.auditorList = data;
              this.auditor = data;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getAuditorList() {
        return _getAuditorList.apply(this, arguments);
      }
      return getAuditorList;
    }(),
    // 获取流转设置角色列表
    getAuditorRoleList: function () {
      var _getAuditorRoleList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var _yield$getProcessSetA2, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return (0, _system.getProcessSetAuditorRoleList)();
            case 2:
              _yield$getProcessSetA2 = _context5.sent;
              data = _yield$getProcessSetA2.data;
              this.auditorRoleList = data;
              this.auditorRole = data;
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getAuditorRoleList() {
        return _getAuditorRoleList.apply(this, arguments);
      }
      return getAuditorRoleList;
    }(),
    //初始化的数据，在第二跳到第三步骤时处理
    initTransferTableData: function initTransferTableData() {
      var _this4 = this;
      this.transferCol = [];
      this.tableData.forEach(function (item, index) {
        item.number = index + 1;
        _this4.transferCol.push({
          label: item.name,
          id: item.id
        });
      });
      this.transferTableData = [];
      this.tableData.forEach(function (item, index) {
        var checked = [];
        checked[index] = false;
        _this4.transferTableData.push({
          id: item.id,
          name: item.name,
          checked: checked
        });
      });
    },
    // 初始化第二第三步骤数据
    initStep: function initStep() {
      var _this5 = this;
      (0, _system.getProcessDefineStatusList)({
        processId: this.currentEditId
      }).then(function (res) {
        if (res.code == 1) {
          _this5.tableData = res.data;
          if (res.data.length > 0) {
            var index = res.data.findIndex(function (item, index) {
              return item.startStatus == 1;
            });
            _this5.radio = index;
            _this5.currentRadio = res.data[0].id;
          }
          _this5.$nextTick(function () {
            _this5.setSort();
          });
          _this5.initTransferTableData();
          if (_this5.transferTableData.length == _this5.tableData.length) {
            (0, _system.getProcessSetList)({
              processId: _this5.currentEditId
            }).then(function (res) {
              if (res.code == 1) {
                _this5.allNode = [];
                _this5.allNode = res.data;
                res.data.forEach(function (item, index) {
                  var rowIndex = _this5.transferTableData.findIndex(function (ele) {
                    return ele.id == item.xProcessNode;
                  });
                  var colIndex = _this5.transferCol.findIndex(function (ele) {
                    return ele.id == item.yProcessNode;
                  });
                  _this5.transferTableData[rowIndex].checked[colIndex] = true;
                });
                _this5.getAuditorList();
                _this5.getAuditorRoleList();
              }
            });
          }
        }
      });
    },
    // 基础信息   保存按钮
    submitForm: function submitForm(formName) {
      var _this6 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.laodingBtn1 = true;
          var committItem = _this6.committeeArr.find(function (ele) {
            return ele.name == _this6.ruleForm.region;
          });
          _this6.currentCommiteeId = committItem.id;
          var reviews = _this6.auditorList.find(function (ele) {
            return ele.id == _this6.ruleForm.reviewId;
          });
          if (_this6.currentEditId) {
            //修改信息
            (0, _system.updateSingleProcessBasic)({
              name: _this6.ruleForm.name,
              commName: _this6.ruleForm.region,
              content: _this6.ruleForm.desc,
              status: _this6.ruleForm.status == '启用' ? '1' : '0',
              autoStatus: _this6.ruleForm.autoStatus == '启用' ? '1' : '0',
              timeLimitStatus: _this6.ruleForm.timeLimitStatus == '启用' ? '1' : '0',
              id: _this6.currentEditId,
              commId: committItem.id,
              reviewId: _this6.ruleForm.reviewId,
              reviewName: reviews.name
            }).then(function (res) {
              if (res.code == 1) {
                _this6.laodingBtn1 = false;
                _this6.$message({
                  message: '修改基础信息成功',
                  type: 'success'
                });
                _this6.getProcessStateList();
              } else {
                _this6.laodingBtn1 = false;
              }
            }).catch(function (err) {
              _this6.laodingBtn1 = false;
            });
          } else {
            //新增信息
            (0, _system.addSingleProcessBasic)({
              name: _this6.ruleForm.name,
              commName: _this6.ruleForm.region,
              content: _this6.ruleForm.desc,
              status: _this6.ruleForm.status == '启用' ? '1' : '0',
              autoStatus: _this6.ruleForm.autoStatus == '启用' ? '1' : '0',
              timeLimitStatus: _this6.ruleForm.timeLimitStatus == '启用' ? '1' : '0',
              commId: committItem.id,
              reviewId: _this6.ruleForm.reviewId,
              reviewName: reviews.name
            }).then(function (res) {
              if (res.code == 1) {
                _this6.canClickIsActive1 = true;
                _this6.laodingBtn1 = false;
                _this6.currentEditId = res.data.id;
                _this6.$message({
                  message: '新增基础信息成功',
                  type: 'success'
                });
                _this6.isActive = 1;
              } else {
                _this6.laodingBtn1 = false;
                _this6.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //取消按钮
    cancel: function cancel() {
      this.$router.push({
        name: 'process'
      });
    },
    setSort: function setSort() {
      var _this7 = this;
      var el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      this.sortable = _sortablejs.default.create(el, {
        ghostClass: 'sortable-ghost',
        // Class name for the drop placeholder,
        setData: function setData(dataTransfer) {
          dataTransfer.setData('Text', '');
        },
        onEnd: function onEnd(evt) {
          var targetRow = _this7.tableData.splice(evt.oldIndex, 1)[0];
          _this7.tableData.splice(evt.newIndex, 0, targetRow);
        }
      });
    },
    // 单选赋值
    getCurrentRow: function getCurrentRow(row, index) {
      this.tableData.forEach(function (item) {
        item.startStatus = 0;
      });
      this.tableData[index].startStatus = "1";
    },
    //添加状态
    addStatus: function addStatus() {
      this.statusTitle = '添加状态';
      this.statusform.originName = '';
      this.statusform.desc = '';
      this.statusform.alias = '';
      if (this.$refs['statusForm']) {
        this.$refs['statusForm'].resetFields();
      }
      this.statusform.alias = '';
      this.statusVisible = true;
    },
    //编辑状态
    editStatus: function editStatus(index, val) {
      this.statusTitle = '编辑状态';
      this.statusVisible = true;
      if (this.$refs['statusForm']) {
        this.$refs['statusForm'].resetFields();
      }
      this.statusform.alias = val.name;
      this.statusform.desc = val.content;
      this.statusIndex = index;
    },
    //删除状态
    clearStatus: function clearStatus(index, rows) {
      rows.splice(index, 1);
      var hasStartStatus = this.tableData.find(function (ele) {
        return ele.startStatus == "1";
      });
      if (!hasStartStatus) {
        this.tableData[0].startStatus = "1";
      }
    },
    //状态原名改变
    statusOriginChange: function statusOriginChange(val) {
      this.currentStatusItem = this.statusList.find(function (item, index) {
        return item.id == val;
      });
      this.statusform.alias = this.currentStatusItem.name;
      this.statusform.originName = this.currentStatusItem.name;
      this.statusform.desc = this.currentStatusItem.content;
    },
    // 状态表单修改提交
    sumbitStatusForm: function sumbitStatusForm(formName) {
      var _this8 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this8.statusTitle == '添加状态') {
            var postData = '';
            postData = {
              content: _this8.statusform.desc,
              endStatus: 0,
              remindDay: _this8.statusform.remindDay,
              fieldId: _this8.currentStatusItem.id,
              name: _this8.statusform.alias,
              number: _this8.tableData.length,
              processId: _this8.currentEditId,
              startStatus: 0,
              type: _this8.currentStatusItem.type
            };
            _this8.tableData.push(postData);
            var hasStartStatus = _this8.tableData.find(function (ele) {
              return ele.startStatus == "1";
            });
            if (!hasStartStatus) {
              _this8.tableData[0].startStatus = "1";
            }
            _this8.$refs[formName].resetFields();
            _this8.statusVisible = false;
          } else {
            _this8.tableData[_this8.statusIndex].content = _this8.statusform.desc;
            _this8.tableData[_this8.statusIndex].name = _this8.statusform.alias;
            _this8.tableData[_this8.statusIndex].remindDay = _this8.statusform.remindDay;
            _this8.$refs[formName].resetFields();
            _this8.statusVisible = false;
          }
        } else {
          return false;
        }
      });
    },
    //状态表单重置
    restStatusForm: function restStatusForm(formName) {
      this.statusVisible = false;
      this.$refs[formName].resetFields();
    },
    //跳转第三步
    nextTo3: function nextTo3() {
      var _this9 = this;
      var hasEndStatus, startStatusIndex;
      this.tableData.forEach(function (item, index) {
        if (item.endStatus == 1) {
          hasEndStatus = item;
        }
        if (item.startStatus == "1") {
          startStatusIndex = index;
        }
      });
      if (this.tableData.length > 0) {
        if (Number(this.tableData[startStatusIndex].endStatus)) {
          this.$message({
            message: '起始状态和结束状态不能相同',
            type: 'warning'
          });
        } else if (!hasEndStatus) {
          this.$message({
            message: '请选择结束状态',
            type: 'warning'
          });
        } else {
          this.initTransferTableData();
          (0, _system.updateProcessStateList)(this.tableData).then(function (res) {
            if (res.code === 1) {
              _this9.$message({
                message: '保存状态成功',
                type: 'success'
              });
              if (_this9.transferTableData.length === _this9.tableData.length) {
                _this9.getProcessSet();
                _this9.getAuditorList();
              }
            }
          });
        }
      } else {
        this.$message({
          message: '请添加状态',
          type: 'warning'
        });
      }
    },
    // 流转设置表格勾选点击
    handleChange: function handleChange(val, rowData, colData) {
      if (val) {
        this.allNode.push({
          xProcessNode: rowData.id,
          yProcessNode: colData.id,
          status: 1
        }); //添加值
      } else {
        //移除值
        var valIndex = this.allNode.findIndex(function (ele) {
          ele.id == rowData.id;
        });
        if (valIndex) {
          this.allNode.splice(valIndex, 1);
        }
      }
    },
    //流转设置表格  图标点击
    editTansferData: function editTansferData(rowData, colData) {
      var _this10 = this;
      this.transferForm.auditor = '';
      this.transferForm.Sentence = '';
      //根据row和col查找当前节点的id
      var index = this.allNode.find(function (ele) {
        return ele.xProcessNode == rowData.id && ele.yProcessNode == colData.id;
      });
      if (index) {
        if (index.id) {
          this.currentFlowId = index.id;
          (0, _system.getProcessSetAuditor)({
            flowId: index.id
          }).then(function (res) {
            if (res.code == 1) {
              if (res.data.length > 0) {
                _this10.nodeOfauditorOpinionList = [];
                _this10.nodeOfauditorOpinionList = res.data;
                _this10.auditorRole = res.data[0].reviewRoleList;
                _this10.auditor = res.data[0].reviewUserList;
                if (res.data.length >= 1) {
                  _this10.transferForm.auditor = res.data[0].reviewName;
                  _this10.transferForm.Sentence = res.data[0].content;
                }
              } else {
                _this10.nodeOfauditorOpinionList = [];
                _this10.auditorRole = [];
                _this10.auditor = [];
              }
              _this10.transferPopupVisible = true;
            }
          });
        } else {
          this.transferPopupVisible = true;
          if (this.$refs['transferForm']) {
            this.$refs['transferForm'].resetFields();
          }
        }
      } else {}
    },
    //审核处理人的改变
    transferAuditorChange: function transferAuditorChange(val) {
      // let auditorIndex = this.
    },
    // 编辑流转  确认按钮
    sumbitTransferForm: function sumbitTransferForm(formName) {
      var _this11 = this;
      this.$refs[formName].validate(function (valid) {
        var id = '',
          reviewId = '';
        reviewId = _this11.auditorList.find(function (ele) {
          return ele.name == _this11.transferForm.auditor;
        });
        if (_this11.nodeOfauditorOpinionList.length >= 1) {
          id = _this11.nodeOfauditorOpinionList[0].id;
        }
        if (valid) {
          (0, _system.updateProcessSetAuditor)([{
            content: _this11.transferForm.Sentence,
            flowId: _this11.currentFlowId,
            id: id,
            reviewRoleId: _this11.auditorRole.join(),
            reviewId: _this11.auditor.join()
          }]).then(function (res) {
            if (res.code == 1) {
              _this11.$message({
                message: '编辑状态节点成功',
                type: 'warning'
              });
              _this11.transferPopupVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    //流转设置总提交
    sumbitTransferSet: function sumbitTransferSet() {
      var _this12 = this;
      if (this.allNode.length > 0) {
        (0, _system.updateProcessNodeList)(this.allNode).then(function (res) {
          if (res.code == 1) {
            _this12.$message({
              message: '修改成功',
              type: 'success'
            });
            _this12.$router.push({
              name: 'process'
            });
          }
        });
      } else {
        this.$message({
          message: '至少勾选一个',
          type: 'warning'
        });
      }
    }
  }
};
exports.default = _default;